<template>
  <div id="hold">

    <ActiveFundingSoonGrid></ActiveFundingSoonGrid>

  </div>
</template>

<script>
  import ActiveFundingSoonGrid from '../components/ActiveFundingSoonGrid.vue'
  export default {
    name: 'FundingSoon',

    components: {
      ActiveFundingSoonGrid
    },
  }
</script>
